import React, { useState, useEffect } from 'react'

import styled from 'styled-components'

import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import AsyncSelect from 'react-select/async'

export const SingleSelect = ({
  options,
  selected,
  onChange,
  placeholder,
  defaultValue,
  title,
  subText,
  wrapperClass,
  marginBottom = '1rem',
}) => {
  return (
    <Wrapper className={wrapperClass} marginBottom={marginBottom}>
      <label>{title}</label>
      <Select
        defaultValue={defaultValue}
        options={options}
        value={selected ?? options[0]}
        onChange={onChange}
        placeholder={placeholder}
      />
      <sub>{subText}</sub>
    </Wrapper>
  )
}

export const SingleAsyncSelect = ({
  selected,
  onChange,
  placeholder,
  promiseOptions,
  title,
  subText,
  wrapperClass,
  marginBottom = '1rem',
  loadingMessage,
  defaultOptions = [],
}) => {
  return (
    <Wrapper className={wrapperClass} marginBottom={marginBottom}>
      <label>{title}</label>
      <AsyncSelect
        defaultOptions={defaultOptions}
        cacheOptions
        loadOptions={promiseOptions}
        onChange={onChange}
        value={selected}
        placeholder={placeholder}
        loadingMessage={() => loadingMessage}
        noOptionsMessage={({ inputValue }) =>
          inputValue.trim() === ''
            ? 'Begin typing to see suggestions'
            : `No results for "${inputValue}"`
        }
      />
      <sub>{subText}</sub>
    </Wrapper>
  )
}

export const MultiSelect = ({
  options,
  selected,
  onChange,
  placeholder,
  title,
  subText,
  wrapperClass,
  marginBottom = '1rem',
}) => {
  return (
    <Wrapper className={wrapperClass} marginBottom={marginBottom}>
      <label>{title}</label>
      <Select
        isMulti
        options={options}
        value={selected}
        onChange={onChange}
        placeholder={placeholder}
      />
      <sub>{subText}</sub>
    </Wrapper>
  )
}

export const CreatableSelectComponent = ({
  id,
  title,
  placeholder,
  noOption = false,
  menuIsOpen,
  selected = [],
  onChange,
  subText,
  wrapperClass,
  marginBottom,
}) => {
  let openMenu = menuIsOpen
  let components = {}

  const [inputValue, setInputValue] = useState('')
  const [value, setValue] = useState(selected)

  useEffect(() => {
    setValue(selected)
  }, [selected])

  if (noOption) {
    components = {
      DropdownIndicator: null,
    }
    openMenu = false
  }

  const createOption = (label) => ({
    label,
    value: label,
  })

  const handleKeyDown = (event) => {
    if (!inputValue) return

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setValue((prev) => [...prev, createOption(inputValue)])
        onChange([...value, createOption(inputValue)])
        setInputValue('')

        event.preventDefault()
    }
  }

  const handleChange = (newValue) => {
    setValue(newValue)
    onChange(newValue)
  }

  return (
    <Wrapper id={id} className={wrapperClass} marginBottom={marginBottom}>
      <label>{title}</label>
      <CreatableSelect
        components={components}
        isClearable
        isMulti
        inputValue={inputValue}
        menuIsOpen={openMenu}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
      />
      <sub>{subText}</sub>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  border-radius: 3px;
  font-size: 0.875rem;
  font-weight: 300;
  margin-bottom: ${({ marginBottom }) => marginBottom};

  label {
    font-size: 0.875rem;
    font-weight: 300;
    margin-bottom: 8px;
    display: block;
  }

  &.error {
    label {
      color: red;
    }

    sub {
      font-size: 13.33px;
      color: red;
      font-weight: 500;
    }

    .css-13cymwt-control {
      border-color: red;
    }
  }
`
